export const theme = {
  colors: {
    header: "#343a40",
    body: "#343a40",
    section: "#343a40",
    footer: "#dee2e6",
    fontColor: "#fff",
  },
  fontSize: {
    input: "2.2rem",
  },
};
